export default [
  {
    name: 'SignatoryTypesList',
    path: '/settings/signatory-types',
    component: () => import('pages/settings/signatory-types/SignatoryTypesList.vue')
  },
  {
    name: 'SignatoryTypesCreate',
    path: '/settings/signatory-types/new',
    component: () => import('pages/settings/signatory-types/SignatoryTypesForm.vue')
  },
  {
    name: 'SignatoryTypesEdit',
    path: '/settings/signatory-types/:id/edit',
    component: () => import('pages/settings/signatory-types/SignatoryTypesForm.vue')
  }
]
